export default __webpack_public_path__ + "static/media/noFilesUser.94f56dcf.png";